import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Card, Col, Row } from "react-bootstrap";
import TextInput from "../../../../../components/formfields/InputField";
import "../style.scss";
import { getSecurityDataSelector } from "../../../../../store/selector/cmsSelector";
import addSecurityDataAction from "../actions";

const validationSchema = Yup.object({
  title: Yup.string().required("Title can not be empty"),
  description: Yup.string().required("Description can not be empty"),
});

function HeroSection() {
  const dispatch = useDispatch();
  const securityData = useSelector(getSecurityDataSelector);
  const [heroEdit, setHeroEdit] = useState(false);

  const initialState = {
    title: securityData?.title ? securityData?.title : "",
    description: securityData?.description ? securityData?.description : "",
  };

  const handleSubmit = (values: any) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("request_type", "short_description");
    dispatch(addSecurityDataAction(formData, setHeroEdit));
  };

  return (
    <Formik enableReinitialize initialValues={initialState} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {({ values, handleChange, handleBlur }) => {
        return (
          <Form>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className={`mb-0 ${heroEdit ? "editTitle" : ""}`}>Hero Section</h6>
                {heroEdit ? (
                  <button className="btn btn-primary" type="submit">
                    Save <i className="fa-regular fa-floppy-disk ms-2" />
                  </button>
                ) : (
                  <span aria-hidden="true" onClick={() => setHeroEdit(true)} className="btn btn-success">
                    Edit <i className="fa-regular fa-pen-to-square ms-2" />
                  </span>
                )}
              </Card.Header>
              <Card.Body className="position-relative">
                <div
                  className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${heroEdit ? "d-none" : ""}`}
                  style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                />
                <Row className="gy-3">
                  <Col xs={12}>
                    <Field
                      label="Title"
                      name="title"
                      component={TextInput}
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Title"
                      readOnly={!heroEdit}
                      disabled={!heroEdit}
                      className={heroEdit ? "editField" : ""}
                    />
                  </Col>
                  <Col xs={12}>
                    <Field
                      label="Description"
                      name="description"
                      component={TextInput}
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Description"
                      readOnly={!heroEdit}
                      disabled={!heroEdit}
                      className={heroEdit ? "editField" : ""}
                      multiline
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
}

export default HeroSection;
